<template lang="pug">
    crud-form( v-bind="formProps" @submitForm="submitForm" )
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
import { CrudForm } from '@/components/reusable_components'
import PrevisionService from '@/services/api/prevision'
//
import { PrevisionFields } from './fields'
//
export default {
    components: {
        'crud-form': CrudForm,
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        formProps() {
            return {
                editable: this.$can('EDIT_PREVISION'),
                readOnly: !this.$can('EDIT_PREVISION'),
                fields: PrevisionFields,
                ref: 'form',
                submitText: 'actualizar',
            }
        },
    },
    methods: {
        /**
         *
         */

        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */

        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        async reset() {
            //
            this.setTitleTopBar('Datos de la prevision')

            //
            const prevision = await PrevisionService.fetchById(
                this.$route.params.id
            )

            //
            this.$refs.form.vmodels.name = prevision.name
            this.$refs.form.vmodels.dependent_rate = prevision.dependent_rate
            this.$refs.form.vmodels.independent_rate =
                prevision.independent_rate
        },

        /**
         *
         */
        showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },

        /**
         *
         */
        async submitForm(event) {
            //
            this.resetSnackbarState()

            //
            const response = await PrevisionService.update(
                this.$route.params.id,
                {
                    ...event,
                }
            )

            //
            switch (response.status) {
                case 'error':
                    this.showSnackbar(
                        'error',
                        'Error.',
                        response.error || response.message
                    )
                    break
                case 'success':
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Datos de la prevision actualizados con éxito.'
                    )
                    break
                default:
                    break
            }
        },
    },
    mounted() {
        this.reset()
    },
    watch: {
        /**
         *
         */
        $route() {
            this.reset()
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PREVISION')) ctx.$router.push('/')
        })
    },
}
</script>

